module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_72-555e1712e4e562c756f8cc257697e701.png";